<template>
  <div>
    <v-autocomplete
      v-model="selectedUsers"
      :items="users"
      item-text="email"
      :item-value="itemValue"
      filled
      :label="label"
      :hide-details="hideDetails"
      :placeholder="placeholder"
      :dense="dense"
      :multiple="multiple"
      :clearable="clearable"
      :loading="loading"
      :return-object="returnObject"
      :prepend-icon="prependIcon"
      :rules="rules"
      :disabled="disabled"
      :readonly="readonly"
      :rounded="rounded"
      ref="autocomplete"
    >
      <template slot="append-outer">
        <slot name="append-outer"></slot>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import usersService from "@/services/users/users.service.js";
import Vue from 'vue'

export default {
  name: "UsersAutocomplete",
  data: function() {
    let selection;
    if(!!this.value) {
      if(this.multiple && !this.returnObject) {
        selection = []
        for(let i = 0; i < this.value.length; i++) {
          selection.push(this.value[i])
        }
      } else if(!this.returnObject) {
        selection = this.value
      } else {
        selection = this.value
      }
    }

    return {
      users: [],
      selectedUsers: selection,
      loading: false
    }
  },
  props: {
    value: {
      default: function() {
        return []
      }
    },
    bus: {
      type: Object,
      default: () => { new Vue() }
    },
    placeholder: {
      type: String,
      default: 'Tutti gli utenti'
    },
    dense: {
      type: Boolean,
      default: false
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    label: {
      type: String,
      default: 'Utente'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      default: 'auto'
    },
    prependIcon: {
      type: String,
      default: 'mdi-account'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    }
  },
  mounted: function() {
    this.loadUsers()

    if(!!this.bus) {
      this.bus.$on('reload', () => {
        this.loadUsers()
      })
      this.bus.$on('focus', () => {
        this.$nextTick(() => {
          this.$refs.autocomplete.focus()
        })
      })
    }
  },
  methods: {
    async loadUsers() {
      this.loading = true

      const users = await usersService.list()
      
      this.users = users
      this.loading = false
    },
    arraysEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length !== b.length) return false;

      for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }
  },
  watch: {
    value(newVal) {
      if(!!newVal && !this.multiple) 
        this.selectedUsers = parseInt(newVal)
      else 
        this.selectedUsers = newVal
    },
    filters() {
      this.loadUsers()
    },
    selectedUsers(newVal) {
      if(this.multiple && !this.arraysEqual(newVal, this.value)) {
        this.$emit('input', newVal)
      } else if(!this.multiple && newVal != this.value) {
        this.$emit('input', newVal)
      }
    }
  }
}
</script>

<style>

</style>